Global.store.getters = {
};